module.exports = __webpack_public_path__ + "assets/media/5.d5f0dbd1.wav";